import React, { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  Alert, 
  AlertTitle,
} from "@mui/material";
import { Theme, useTheme } from '@mui/material/styles'
import { createStyles, makeStyles } from '@mui/styles';
import { useLocalStorage } from "../../utils/LocalStorageHook";
import { GetBatchStatus } from "../../utils/GetAdmin";
import {checkForRole} from "../../utils/GetAuth";
import LockIcon from '@mui/icons-material/Lock';

import {
  WatchLater,
  Error,
  CheckCircle,
  Warning,
 } from '@mui/icons-material';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    centerDiv: {
      textAlign: "center",
    },
    root: {},
    divWidth: {
      width: "100%",
    },
    gridSpaceable: {
      padding: theme.spacing(2),
    },
    gridMarginTop: {
      marginTop: theme.spacing(2),
    },
    primary: {
      marginTop: theme.spacing(2),
    },
    
    paragraph: {
      padding: theme.spacing(1),
    },
    paragraphAct: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
    paper: {
        position: 'absolute',
        backgroundColor: theme.palette.background.paper,
        border: `1px solid`,
        borderColor: theme.palette.border.main, 
        boxShadow: theme.shadows[4],
        padding: theme.spacing(2, 2, 2),
    },
  })
);
export default function BatchMonJobStatus() {
  const classes = useStyles();
  const [batchStatus, setBatchStatus] = useState<any[]>([]);
  const [batchLogs, setBatchLogs] = useState<any[]>([]);
  const [cur, setCur] = useState<{runID:string,type:string,name:string}|undefined>();
  const [salesOrg,] = useLocalStorage("SETTINGS.salesOrg", "");
  const [doneLoading, setDoneLoading] = React.useState<boolean>();
  const [clientId,] = useLocalStorage("SETTINGS.clientId", "100");
  const enabled = checkForRole(clientId,salesOrg,'security_admin');

  const getStatusIcon = (hasError:boolean, isDone:boolean) =>{
    let icon = <WatchLater/>
    if(isDone) icon = <CheckCircle style={{color:"green"}}/>
    if(hasError) icon = <Error style={{color:"red"}}/>
    return icon
  }
  
  const header =  document.querySelector('ResponsiveDrawer')
  const headerAdj = header?header.clientHeight:250;
  const [TABLE_BODY_HEIGHT, setTABLE_BODY_HEIGHT] = React.useState<string>(`${window.innerHeight - headerAdj }px`);
  window.addEventListener('resize', ()=>{
    setTABLE_BODY_HEIGHT(`${window.innerHeight - headerAdj }px`);
  })
  
  useEffect(() => {
    if (doneLoading) return;
        GetBatchStatus(salesOrg).then((v) => {
          setDoneLoading(true);
          if(v){
            setBatchStatus(v.data.batchStatus);
            setBatchLogs(v.data.batchLogs);
          }
        });
  }, [batchStatus, doneLoading, salesOrg]);
  return (
    <div className={classes.root}>
      {doneLoading && enabled? (
        <div>
          <Card>
            <CardContent>
              <Typography variant="h4" className={classes.paragraph}>
                Batch Monitor
              </Typography>
              <TableContainer style={{maxHeight: TABLE_BODY_HEIGHT,}}>
                <Table stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell></TableCell>
                      <TableCell>Type</TableCell>
                      <TableCell>Name</TableCell>
                      <TableCell>Start (server time)</TableCell>
                      <TableCell>Seconds</TableCell>
                      <TableCell>Error</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {batchStatus.map((bs:any) => (
                      <TableRow onClick={()=> setCur({runID:bs.RunID,type:bs.ProcessType,name:bs.ProcessName})}>
                        <TableCell>
                          {getStatusIcon(bs.hasError,bs.isDone)}
                        </TableCell>
                        <TableCell>{bs.ProcessType}</TableCell>
                        <TableCell>{bs.ProcessName}</TableCell>
                        <TableCell>{(new Date(bs.startTime)).toLocaleString()}</TableCell>
                        <TableCell>{bs.runSeconds}</TableCell>
                        <TableCell>{(bs.hasError === 1)?<Warning/>:<div/>}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </CardContent>
          </Card>
          <br/>
          {cur?(
            <Card>
              <Typography variant="h6" className={classes.paragraph}>
                {cur.type}: {cur.name} 
                <br/>{cur.runID}
              </Typography>
              <CardContent>
                <TableContainer style={{maxHeight: TABLE_BODY_HEIGHT,}}>
                  <Table stickyHeader>
                    <TableHead>
                      <TableRow>
                        <TableCell>ID</TableCell>
                        <TableCell>Log Time (server time)</TableCell>
                        <TableCell>Step</TableCell>
                        <TableCell>Status</TableCell>
                        <TableCell>Message</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {batchLogs.filter(bl=>bl.RunID === cur.runID).sort((a,b)=>a.ID-b.ID).map((bl:any) => (
                        <TableRow>
                          <TableCell>{bl.ID}</TableCell>
                          <TableCell>{(new Date(bl.LogDateTime)).toLocaleString()}</TableCell>
                          <TableCell>{bl.StepName}</TableCell>
                          <TableCell>{bl.StepStatus}</TableCell>
                          <TableCell>{bl.LogMessage}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </CardContent>
            </Card>
          ):(<div/>)}
        </div>
      ) : ( enabled ? (
        <div className={classes.centerDiv}>
          <CircularProgress color="primary" />
        </div>) : (
          <Alert severity="error">
            <AlertTitle><LockIcon/> Access Error</AlertTitle>   
            You do not currently have access to <strong>Security Admin</strong> activities for the <strong>{salesOrg}</strong> bottler. 
          </Alert>
        )
      )}
    </div>
  );
}